// Utils
import { createNamespace } from '../utils';
import { inherit } from '../utils/functional';
import { BORDER_TOP } from '../utils/constant';
// Components
import Cell from '../cell';
import CellGroup from '../cell-group';
const [createComponent, bem] = createNamespace('panel');
function Panel(h, props, slots, ctx) {
    const Content = () => [
        slots.header ? (slots.header()) : (<Cell icon={props.icon} label={props.desc} title={props.title} value={props.status} class={bem('header')} valueClass={bem('header-value')}/>),
        <div class={bem('content')}>{slots.default && slots.default()}</div>,
        slots.footer && (<div class={[bem('footer'), BORDER_TOP]}>{slots.footer()}</div>),
    ];
    return (<CellGroup class={bem()} scopedSlots={{ default: Content }} {...inherit(ctx, true)}/>);
}
Panel.props = {
    icon: String,
    desc: String,
    title: String,
    status: String,
};
export default createComponent(Panel);
